import React from 'react';
import "./FloorSelector.css"
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

function FloorSelector(props) {

	let bname_buttons = [];
	if (props.buildingNames) {
		bname_buttons = props.buildingNames.map( (title, index) => {
			return (<ToggleButton className="sb-bname-button" value={ index } size="small" key={index}>{ title }</ToggleButton>);
		} );
	}

	let fname_buttons = null;
	let ftoggle = null;

	if (props.building) {
		const bld = props.building;
		fname_buttons = [];
		bld.forEachFloor( floor => {
			const inline_style = {
				boxShadow: `0 -9px 6px -8px ${ floor.getEditorColorAsCSS(0.75) } inset`
			};

			fname_buttons.push(<ToggleButton style={ inline_style } key={ floor.id } value={ floor.id } onClick={ props.onFloorClick }>{floor.title}</ToggleButton>);
		});

		ftoggle = (<div><h3>Floor</h3><ToggleButtonGroup className="bd-floor-selector-group" value={ props.editingFloor?.id } size="small">
			{ fname_buttons }
		</ToggleButtonGroup></div>);
	}

	return (<div className="bd-area-selector-toggle"><h3>Building</h3><ToggleButtonGroup value={ props.activeBuildingIndex } size="small">
		{ bname_buttons }
	</ToggleButtonGroup>
	{ ftoggle }
	</div>);
}

export default FloorSelector;